exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-x{float:right}.m-content{padding-top:15px;padding-left:15px}.m-text{padding-bottom:5px;color:#c8c8c8}.m-button{padding-top:15px;color:#c8c8c8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e4f57fb6","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/modals/AiffModal.vue
// module id = ZmIG
// module chunks = 3 4